var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.5 141.7",
    style: {
      enableBackground: "new 0 0 368.5 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F59E00;}\n\t.st1{fill:#E30613;}\n\t.st2{fill:#05672F;}\n\t.st3{fill:#FFDF00;}\n\t.st4{fill:#5DB34C;}\n\t.st5{fill:#007932;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_391_",
    className: "st0",
    points: "8.5,136.1 65.2,136.1 65.2,96.4 36.9,68 8.5,96.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_392_",
    className: "st1",
    points: "70.9,136.1 127.6,136.1 127.6,39.7 99.2,11.3 70.9,39.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_393_",
    className: "st2",
    points: "133.2,136.1 189.9,136.1 189.9,62.4 161.6,34 133.2,62.4 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_394_",
    className: "st3",
    points: "195.6,136.1 252.3,136.1 252.3,85 223.9,56.7 195.6,85 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_395_",
    className: "st4",
    points: "258,136.1 314.6,136.1 314.6,107.7 286.3,79.4 258,107.7 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_396_",
    x: 140.3,
    y: 73.7,
    className: "st5",
    width: 19.8,
    height: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_397_",
    x: 163,
    y: 73.7,
    className: "st5",
    width: 19.8,
    height: 17
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_399_",
    x: 140.3,
    y: 93.5,
    className: "st5",
    width: 19.8,
    height: 17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_398_",
    x: 163,
    y: 93.5,
    className: "st5",
    width: 19.8,
    height: 17
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEaLogo);
export default __webpack_public_path__ + "static/media/EA_logo.2dabda72d4b97b67bfa679f048e0f3a3.svg";
export { ForwardRef as ReactComponent };